import axios from "functions/axios";

export const AllApplicationListAPI = ({
  page = 1,
  page_size = 15,
  ordering = "create_at",
  filters = {},
} = {}) =>
  axios
    .get("application/admin/all-application/list/", {
      params: {
        page,
        page_size,
        ordering,
        ...filters,
      },
    })
    .then((res) => res.data);

export const ExportAllApplicationListAPI = ({ ordering = "create_at", filters = {} } = {}) =>
  axios
    .get("application/admin/all-application/list/export/", {
      params: {
        ordering,
        ...filters,
      },
      responseType: "blob",
    })
    .then((res) => res.data);

export const ReferralApplicationListAPI = ({
  page = 1,
  page_size = 15,
  ordering = "create_at",
  filters = {},
} = {}) =>
  axios
    .get("application/admin/referral-application/list/", {
      params: {
        page,
        page_size,
        ordering,
        ...filters,
      },
    })
    .then((res) => res.data);

export const ExportReferralApplicationListAPI = ({ ordering = "create_at", filters = {} } = {}) =>
  axios
    .get("application/admin/referral-application/list/export/", {
      params: {
        ordering,
        ...filters,
      },
      responseType: "blob",
    })
    .then((res) => res.data);

export const DetailApplicationApi = (pk) =>
  axios.get(`application/admin/all-application/detail/${pk}/`).then((res) => res.data);

export const DeleteApplication = (pk) =>
  axios.delete(`application/admin/all-application/delete/${pk}/`).then((res) => res.data);

export const CreateCommentForApplication = ({ application, status, message }) =>
  axios
    .post("application/admin/application/timeline/", {
      application,
      status,
      message,
    })
    .then((res) => res.data);

export const UpdateApplicationStatus = ({ application, status, message = null }) =>
  axios
    .put(`application/admin/application/update/${application}/`, {
      status,
      message,
    })
    .then((res) => res.data);

export const GetAllAppListDashboard = ({ status, page, page_size = 15 }) =>
  axios
    .get("application/admin/all-application/list/", {
      params: { status, page, page_size },
    })
    .then((res) => res.data);

export const GetDashboardHeatMap = () =>
  axios.get("admin/report/hieatmap/?date=month").then((res) => res.data);

export const GetDashboardWorldWideData = () =>
  axios.delete("admin/report/choropleth/?date=all").then((res) => res.data);

export const IssuanceLetterApplication = ({
  application,
  count_semesters,
  fee,
  semesters_year,
  semesters_season,
  register_start_date,
  register_end_date,
  start_program_date,
}) =>
  axios
    .post("application/admin/application/issuance_letter/", {
      application,
      count_semesters,
      fee,
      semesters_year,
      semesters_season,
      register_start_date,
      register_end_date,
      start_program_date,
    })
    .then((res) => res.data);
